import React from 'react';
import { Link } from 'react-router-dom';
import { 
  RiShieldCheckLine, 
  RiArrowLeftLine,
  RiFileList3Line,
  RiUserSettingsLine,
  RiLockPasswordLine,
  RiShieldCrossLine,
  RiLinksLine,
  RiFileEditLine,
  RiInformationLine,
  RiGlobalLine,
  RiExternalLinkLine
} from 'react-icons/ri';
import SEO from '../components/SEO';
import './Terms.css';

const Terms = () => {
  return (
    <>
      <SEO
        title="Terms of Service - NEIR BTRC | Official Government Terms & Conditions"
        description="Read the Terms of Service for the National Equipment Identity Register (NEIR) by Bangladesh Telecommunication Regulatory Commission (BTRC). Official government terms and conditions for using the NEIR system, IMEI verification services, and mobile device registration portal. Understand your rights and responsibilities when using government mobile database services."
        keywords="Terms of Service, NEIR BTRC Terms, NEIR Bangladesh Terms, NEIR.gov.bd Terms, NEIR.btrc.gov.bd Terms, neir.btrc.gov.bd Terms, NEIR terms, BTRC terms of service, government terms and conditions, official NEIR terms, Bangladesh government terms, mobile device registration terms, IMEI verification terms, government mobile database terms, official government terms, BTRC terms of use, NEIR terms of service, government telecommunications terms, official mobile services terms, Bangladesh telecom regulatory terms, government mobile database terms, official device registration terms, government mobile verification terms, official government portal terms, BTRC legal terms, NEIR legal terms, government mobile services terms, official mobile database terms, government telecommunications terms of service, Bangladesh mobile network terms, official device verification terms, government mobile registration terms, official government services terms, BTRC official terms, NEIR official terms, neir.btrc.gov.bd terms, www.neir.btrc.gov.bd terms, neir portal terms, btrc neir portal terms, neir btrc website terms, neir btrc official terms, neir btrc legal terms, neir btrc bangladesh terms, neir btrc gov terms, neir btrc government terms, .gov.bd terms, gov.bd domain terms, government domain Bangladesh terms, official government domain terms, btrc.gov.bd terms, neir.btrc.gov.bd terms, www.btrc.gov.bd terms, www.neir.btrc.gov.bd terms"
        ogTitle="Terms of Service - NEIR BTRC | Official Government Terms"
        ogDescription="Read the Terms of Service for the National Equipment Identity Register (NEIR) by Bangladesh Telecommunication Regulatory Commission (BTRC)."
        ogImage="/images/btrc-logo.png"
        canonicalUrl="https://neir.btrc.gov.bd/terms"
      />
      <div className="terms-page">
      <div className="terms-header">
        <div className="container">
          <Link to="/" className="back-link">
            <RiArrowLeftLine /> Back to Home
          </Link>
          <div className="terms-title-section">
            <div className="terms-icon">
              <RiShieldCheckLine />
            </div>
            <h1>Terms of Service</h1>
            <p>Last updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</p>
          </div>
        </div>
      </div>

      <div className="terms-content">
        <div className="container">
          <div className="terms-section">
            <h2>
              <RiFileList3Line className="section-icon" />
              1. Acceptance of Terms
            </h2>
            <p>
              By accessing and using the National Equipment Identity Register (NEIR) website and services, 
              you accept and agree to be bound by the terms and provision of this agreement. If you do not 
              agree to abide by the above, please do not use this service.
            </p>
          </div>

          <div className="terms-section">
            <h2>
              <RiFileEditLine className="section-icon" />
              2. Use License
            </h2>
            <p>
              Permission is granted to temporarily access the materials on NEIR's website for personal, 
              non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, 
              and under this license you may not:
            </p>
            <ul>
              <li>Modify or copy the materials</li>
              <li>Use the materials for any commercial purpose or for any public display</li>
              <li>Attempt to reverse engineer any software contained on NEIR's website</li>
              <li>Remove any copyright or other proprietary notations from the materials</li>
            </ul>
          </div>

          <div className="terms-section">
            <h2>
              <RiShieldCheckLine className="section-icon" />
              3. IMEI Verification Service
            </h2>
            <p>
              The IMEI verification service provided by NEIR is for informational purposes only. While we 
              strive to provide accurate information, we do not guarantee the accuracy, completeness, or 
              timeliness of the information provided. Users are responsible for verifying the information 
              through official channels.
            </p>
          </div>

          <div className="terms-section">
            <h2>
              <RiUserSettingsLine className="section-icon" />
              4. User Responsibilities
            </h2>
            <p>Users of the NEIR service agree to:</p>
            <ul>
              <li>Provide accurate and truthful information when using our services</li>
              <li>Not use the service for any illegal or unauthorized purpose</li>
              <li>Not attempt to gain unauthorized access to any part of the system</li>
              <li>Respect the privacy and rights of other users</li>
              <li>Report any security vulnerabilities or issues immediately</li>
            </ul>
          </div>

          <div className="terms-section">
            <h2>
              <RiLockPasswordLine className="section-icon" />
              5. Privacy and Data Protection
            </h2>
            <p>
              Your use of NEIR services is also governed by our Privacy Policy. Please review our Privacy 
              Policy to understand our practices regarding the collection and use of your personal information.
            </p>
          </div>

          <div className="terms-section">
            <h2>
              <RiShieldCrossLine className="section-icon" />
              6. Limitation of Liability
            </h2>
            <p>
              In no event shall NEIR or its suppliers be liable for any damages (including, without limitation, 
              damages for loss of data or profit, or due to business interruption) arising out of the use or 
              inability to use the materials on NEIR's website, even if NEIR or a NEIR authorized representative 
              has been notified orally or in writing of the possibility of such damage.
            </p>
          </div>

          <div className="terms-section">
            <h2>
              <RiFileEditLine className="section-icon" />
              7. Revisions and Errata
            </h2>
            <p>
              The materials appearing on NEIR's website could include technical, typographical, or photographic 
              errors. NEIR does not warrant that any of the materials on its website are accurate, complete, 
              or current. NEIR may make changes to the materials contained on its website at any time without notice.
            </p>
          </div>

          <div className="terms-section">
            <h2>
              <RiLinksLine className="section-icon" />
              8. Links to Other Websites
            </h2>
            <p>
              NEIR has not reviewed all of the sites linked to its website and is not responsible for the contents 
              of any such linked site. The inclusion of any link does not imply endorsement by NEIR of the site. 
              Use of any such linked website is at the user's own risk.
            </p>
          </div>

          <div className="terms-section">
            <h2>
              <RiFileEditLine className="section-icon" />
              9. Modifications to Terms
            </h2>
            <p>
              NEIR may revise these terms of service at any time without notice. By using this website you are 
              agreeing to be bound by the then current version of these terms of service.
            </p>
          </div>

          <div className="terms-section">
            <h2>
              <RiInformationLine className="section-icon" />
              10. Contact Information
            </h2>
            <p>
              If you have any questions about these Terms of Service, please contact us through our 
              <Link to="/contact" className="inline-link"> Contact page</Link> or visit the official 
              BTRC website for more information.
            </p>
          </div>

          {/* Official Links Section */}
          <div className="official-links-section">
            <h2 className="official-links-title">
              <RiGlobalLine className="title-icon" />
              Important Official Links
            </h2>
            <div className="official-links-grid">
              <a 
                href="https://neir.btrc.gov.bd" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="official-link"
              >
                <RiGlobalLine className="link-icon" />
                <div className="link-content">
                  <span className="link-title">Official NEIR Portal</span>
                  <span className="link-url">neir.btrc.gov.bd</span>
                </div>
                <RiExternalLinkLine className="external-icon" />
              </a>
              
              <a 
                href="https://btrc.gov.bd" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="official-link"
              >
                <RiGlobalLine className="link-icon" />
                <div className="link-content">
                  <span className="link-title">BTRC Official Website</span>
                  <span className="link-url">btrc.gov.bd</span>
                </div>
                <RiExternalLinkLine className="external-icon" />
              </a>
              
              <a 
                href="https://btrc.gov.bd/imei-check" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="official-link"
              >
                <RiShieldCheckLine className="link-icon" />
                <div className="link-content">
                  <span className="link-title">IMEI Check Service</span>
                  <span className="link-url">Check Device Status</span>
                </div>
                <RiExternalLinkLine className="external-icon" />
              </a>
              
              <a 
                href="https://btrc.gov.bd/device-registration" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="official-link"
              >
                <RiFileList3Line className="link-icon" />
                <div className="link-content">
                  <span className="link-title">Device Registration</span>
                  <span className="link-url">Register Your Device</span>
                </div>
                <RiExternalLinkLine className="external-icon" />
              </a>
              
              <a 
                href="https://btrc.gov.bd/complaints" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="official-link"
              >
                <RiInformationLine className="link-icon" />
                <div className="link-content">
                  <span className="link-title">File a Complaint</span>
                  <span className="link-url">Report Issues</span>
                </div>
                <RiExternalLinkLine className="external-icon" />
              </a>
              
              <Link to="/privacy" className="official-link">
                <RiLockPasswordLine className="link-icon" />
                <div className="link-content">
                  <span className="link-title">Privacy Policy</span>
                  <span className="link-url">View Privacy Policy</span>
                </div>
                <RiExternalLinkLine className="external-icon" />
              </Link>
            </div>
          </div>
        </div>
      </div>
      </div>
    </>
  );
};

export default Terms;

